import * as React from 'react';
export function createChildIsTypeOf(type) {
    return function childIsTypeOf(child) {
        return child && child.type === type;
    };
}
export function useMergedRefs(...refs) {
    return React.useMemo(() => {
        const filteredRefs = refs.filter((ref) => ref !== null);
        if (filteredRefs.length === 0) {
            return null;
        }
        return function refCallback(node) {
            refs.forEach((ref) => {
                if (ref === null) {
                    return;
                }
                if (typeof ref === 'function') {
                    ref(node);
                    return;
                }
                else {
                    try {
                        ref.current = node;
                    }
                    catch (error) {
                        throw new Error(`Unable to assign ref: ${ref}, node: ${node}`);
                    }
                }
            });
        };
    }, [refs]);
}
//# sourceMappingURL=component-util.js.map